import React from 'react'
import Footer from './components/Footer'
import SloganSection from './sections/SloganSection'
import Header from './components/Header'
import HeroSection from './sections/HeroSection'
import FestivalSection from './sections/FestivalSection'
import ProgramSection from './sections/ProgramSection'
import TheatresSection from './sections/TheatresSection'
import SponsorSection from './sections/SponsorSection'
import ApplicationForm from './sections/ApplicationForm'
import {Link} from "react-router-dom";
import Festival2025Early from "./sections/Festival2025Early";
import PDFViewer from "./sections/PDFViewer";






export default function Main() {

    const pdfUrl = '/program_2025.pdf';

    const destekciler=()=>{

        return(

            <section className="ts-intro-sponsors" style={{backgroundImage: "url(images/sponsors/sponsor_img.jpg)"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 className="section-title white">MEDYA DESTEKÇİSİ
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="sponsors-logo text-center">

                                <Link to="#">
                                    <img src="./images/lavarda.png" style={{width: "150px"}} alt=""/></Link>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
    return (
        <React.Fragment>
    <Header/>
            <ApplicationForm/>

            {
          //  <SloganSection/>

          

            <ProgramSection year={2026}/>
            //<SloganSection/>

                //   <SponsorSection/>

             //   <destekciler/>
                // <TheatresSection/>
            }




            {
                // <TheatresSection/>
            }

            <FestivalSection/>

            {
                //   <PDFViewer pdfUrl={pdfUrl}/>
            }




            <Footer/>
        </React.Fragment>
    )
}
